// apolo/src/lib/loop/planHonestOutcome.js — harness sweep #4.
// @arch:pure-engine
//
// PURE: decide se um run ENTREGOU o plano aprovado (→ run_result ok:true marca os
// todos done). Extraído de SessionWorkspace pra manter o shell fino (o dp-loc ratchet
// da SessionWorkspace é apertado) e pra ser unit-testável.
//
// O BUG (#4): SessionWorkspace usava `runOk` = "chegou ao fim do try sem lançar" como
// sinal de entrega. Isso é FALSO — um run que recusou, foi bloqueado (DAG blocked),
// errou, ou reprovou no verificador ainda "não lança", e marcava 100% dos todos como
// done sem evidência (o "0/N" que na verdade não entregou). Aqui exigimos sinais
// HONESTOS do resultado do agente.

// FASE-12 E6-T01 — stopReasons TERMINAIS-MAS-INCOMPLETOS. O loop devolve ok:true
// nesses casos (ele terminou de rodar), mas NÃO entregou o plano: estourou o
// orçamento de passos, entrou em spiral/repeat, o contexto explodiu, o follow-up
// falhou, ou a auto-correção desistiu no vermelho. Marcar os todos 100% done aqui
// é o "verde silencioso" que a auditoria proíbe.
const NON_DONE_STOP = new Set([
  'max_iterations',
  'tools_done_followup_failed',
  'followup_failed',
  'tool_failure_spiral',
  'tool_repeat_loop',
  'stall',
  'stall_gave_up',
  'context_overflow',
  'unbacked_green_claim',
  'autocorrect_cap',
  'no_root',
]);

/**
 * @param {{ finished?: boolean, aborted?: boolean, agentResult?: any }} p
 *   finished    — o run chegou ao fim do try (não lançou)
 *   aborted     — o usuário/loop abortou (Stop)
 *   agentResult — o retorno do runLocalAgentLoop / DAG ({ ok, stopReason, autoCorrect:{reachedGreen} })
 * @returns {boolean} true só quando há evidência honesta de entrega
 */
export function planRunHonestlyDone({ finished, aborted, agentResult } = {}) {
  if (!finished || aborted) return false;
  // O loop/DAG reportou falha explícita (DAG blocked → ok:false, erro de rota, etc.).
  if (agentResult && agentResult.ok === false) return false;
  // E6-T01 — ok:true mas terminou por esgotamento/loop/overflow ⇒ NÃO entregou.
  if (agentResult && NON_DONE_STOP.has(agentResult.stopReason)) return false;
  // Um verificador RODOU e reprovou → não é verde (reachedGreen:false). undefined =
  // nenhum verificador rodou (tarefa sem scripts/aceitação) → não gateia por isso.
  const reachedGreen = agentResult && agentResult.autoCorrect
    ? agentResult.autoCorrect.reachedGreen
    : undefined;
  if (reachedGreen === false) return false;
  return true;
}
